import { useParams , NotesComponent, EntityType, Box } from '../../utils/globalImports';

const ClientNotes: React.FC<{ clientId: number }> = ({ clientId }) => {

  return (
    <Box sx={{mt: 2}}>
      <NotesComponent
      resourceId={Number(clientId)}
      title="Client"
      entityTypeId={EntityType.Client}
      entityId={Number(clientId)}
      searchbarText="Search for notes/comments"
    />
    </Box>
    
  );
};

export default ClientNotes;
